export enum LayoutsMap {
  DEFAULT = 'DEFAULT',
  HAPPY_FLOW = 'HAPPY_FLOW',
  EDGE_CASE = 'EDGE_CASE',
  BASIC = 'BASIC',
}

export enum RoutesMap {
  WELCOME = 'WELCOME',
  PHONE = 'PHONE',
  PERSONAL_DETAILS = 'PERSONAL_DETAILS',
  IDENTITY = 'IDENTITY',
  HOME_ADDRESS = 'HOME_ADDRESS',
  PLAN_SELECTION = 'PLAN_SELECTION',
  KNOW_YOUR_BUSINESS = 'KNOW_YOUR_BUSINESS',
  BUSINESS_TYPE_SELECTION = 'BUSINESS_TYPE_SELECTION',
  BUSINESS_ADDRESS = 'BUSINESS_ADDRESS',
  INDUSTRY = 'INDUSTRY',
  OWNER_CENTER = 'OWNER_CENTER',
  ADD_OWNER = 'ADD_OWNER',
  KYB_PENDING = 'KYB_PENDING',
  VERIFICATION_CENTER = 'VERIFICATION_CENTER',
  REVIEW = 'REVIEW',
  SUCCESS = 'SUCCESS',
  FAILD_UPLOAD = 'FAILD_UPLOAD',
  DEBIT_CARD_NAME = 'DEBIT_CARD_NAME',
  GENERIC_MESSAGE_PAGE = 'GENERIC_MESSAGE_PAGE',
  SOCURE_DOC_V = 'SOCURE_DOC_V',
  UNDER_REVIEW = 'UNDER_REVIEW',
  ACCOUNT_OPENING_REASON = 'ACCOUNT_OPENING_REASON',
  INVITE_TEAM_MEMBER_INTRO = 'INVITE_TEAM_MEMBER_INTRO',
  VERIFY_PHONE_NUMBER = 'VERIFY_PHONE_NUMBER',
  INVITE_ACCOUNTANT_FORM = 'INVITE_ACCOUNTANT_FORM',
  INVITE_ADMIN_FORM = 'INVITE_ADMIN_FORM',
  SET_PASSWORD = 'SET_PASSWORD',
  INVITE_TEAM_MEMBER_FINISHED = 'INVITE_TEAM_MEMBER_FINISHED',
}

// Used for TabIndexing form values
export function getRouteOrdinal(route: RoutesMap): number {
  return Object.keys(RoutesMap).indexOf(route) * 100;
}

export interface IRoute {
  id: string;
  name: string;
  path: string;
  layoutType: LayoutsMap;
  groupId?: string;
}
